import { prepareEnvironmentConfig } from "./prepare";
import {
  readXcoreConfig,
  readXcoreConfigSync,
  getXcoreConfigPath as readXcoreConfigPath,
  getXcoreConfigPathSync as readXcoreConfigPathSync,
} from "./read";
import { XcoreConfigRawValue } from "./types";
import { validateRawConfig } from "./validate";
import { XcoreConfig } from "./XcoreConfig";

let config: XcoreConfig;

/**
 * @throws {ConfigError}
 */
export const getXcoreConfig = async (skipConfigValidation?: boolean, configProvided?: XcoreConfigRawValue): Promise<XcoreConfig> => {
  if (config) {
    return config;
  }

  const configRaw = configProvided ?? (await readXcoreConfig());

  const configWithEnvResolved = prepareEnvironmentConfig(configRaw, skipConfigValidation);

  config = new XcoreConfig(configWithEnvResolved);

  return config;
};

/**
 * @throws {ConfigError}
 */
export const getXcoreConfigSync = (): XcoreConfig => {
  const configRaw = readXcoreConfigSync();

  validateRawConfig(configRaw);

  if (config) {
    return config;
  }

  const configWithEnvResolved = prepareEnvironmentConfig(configRaw);

  config = new XcoreConfig(configWithEnvResolved);

  return config;
};

export const getXcoreConfigPathSync = readXcoreConfigPathSync;
export const getXcoreConfigPath = readXcoreConfigPath;
